// extracted by mini-css-extract-plugin
export default {"container":"Cj-z","blurb":"Dj-z","links":"Ej-z"};